import { render, staticRenderFns } from "./DeleteUnit.vue?vue&type=template&id=4c9f4772&"
import script from "./DeleteUnit.vue?vue&type=script&lang=ts&"
export * from "./DeleteUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports